import React from "react";
import Section from "../ui/Section/Section";
import { Grid } from "../ui/Grid/Grid";
import KpiCard from "../ui/Card/KpiCard";
import ChartCard from "../ui/Card/ChartCard";
import GaugeStat from "../ui/GaugeStat/GaugeStat";
import SectionSkeleton from "../ui/SectionSkeleton/SectionSkeleton";
import { KPI, SECTIONS } from "../../constants";
import { fmt1, fmt1OrDash } from "../../functions/format";
import { CHART_COLORS } from "../../styles/theme";

const { id, title } = SECTIONS.retention;

const SKELETON_ROWS = [
    { cols: 3, cards: [3, 3, 3] },
    { cols: 3, cards: [1, 1] },
];

const RetentionSection = ({ data, isLoading }) => {
    if (isLoading && !data) {
        return (
            <Section id={id} title={title}>
                <SectionSkeleton rows={SKELETON_ROWS} />
            </Section>
        );
    }

    if (!data) return null;

    const gauges = [
        {
            key: "retention",
            title: "Taux de rétention",
            pct: data.tauxRetention,
            color: CHART_COLORS.violet,
            sub: "sur 12 mois",
        },
        {
            key: "essai",
            title: "Confirmation période d’essai",
            pct: data.confirmationEssai,
            color: CHART_COLORS.violet,
            sub: "des recrutements",
        },
        {
            key: "recrutement",
            title: "Recrutement réussi (12 mois)",
            pct: data.recrutementReussi,
            color: CHART_COLORS.blue,
            sub: "encore présents",
        },
    ];

    return (
        <Section id={id} title={title}>
            <Grid cols={3}>
                {gauges.map((g) => (
                    <ChartCard key={g.key} title={g.title}>
                        <GaugeStat
                            pct={g.pct ?? 0}
                            color={g.color}
                            unit={g.pct === null ? undefined : "%"}
                            sub={g.sub}
                            value={fmt1OrDash(g.pct)}
                            tip={
                                g.pct === null
                                    ? undefined
                                    : `${g.title} : ${fmt1(g.pct)} % ${g.sub}`
                            }
                        />
                    </ChartCard>
                ))}
            </Grid>
            <Grid cols={3} $mt>
                <KpiCard
                    label={KPI.anciennete.label}
                    unit={KPI.anciennete.unit}
                    value={fmt1OrDash(data.anciennete)}
                    section={id}
                    delta={null}
                />
                <KpiCard
                    label={KPI.mobilite.label}
                    unit={KPI.mobilite.unit}
                    value={fmt1OrDash(data.mobilite)}
                    section={id}
                    delta={null}
                />
            </Grid>
        </Section>
    );
};

export default RetentionSection;
